{
  "de": {
    "chart": {
      "labels": {
        "view": {
          "one": "%{label}:<br><b>%{count}</b> Anzeige",
          "other": "%{label}:<br><b>%{count}</b> Anzeigen"
        },
        "ship": {
          "one": "%{label}:<br><b>%{count}</b> Schiff",
          "other": "%{label}:<br><b>%{count}</b> Schiffe"
        },
        "ship-pie": {
          "one": "%{label}:<br><b>%{count}</b> Schiff (%{percentage} %)",
          "other": "%{label}:<br><b>%{count}</b> Schiffe (%{percentage} %)"
        },
        "component-pie": {
          "one": "%{label}:<br><b>%{count}</b> Komponente (%{percentage} %)",
          "other": "%{label}:<br><b>%{count}</b> Komponenten (%{percentage} %)"
        },
        "user": {
          "one": "%{label}:<br><b>%{count}</b> Benutzer",
          "other": "%{label}:<br><b>%{count}</b> Benutzer"
        },
        "user-pie": {
          "one": "%{label}:<br><b>%{count}</b> Benutzer (%{percentage} %)",
          "other": "%{label}:<br><b>%{count}</b> Benutzer (%{percentage} %)"
        },
        "visit": {
          "one": "%{label}:<br><b>%{count}</b> Besuch",
          "other": "%{label}:<br><b>%{count}</b> Besuche"
        },
        "supporterContribution": {
          "amount": "Beiträge: <b>%{amount}</b>",
          "goal": "Ziel: <b>%{amount}</b>",
          "count": {
            "one": "<b>%{count}</b> Unterstützer",
            "other": "<b>%{count}</b> Unterstützer"
          }
        }
      },
      "states": {
        "empty": "Noch keine Daten für dieses Diagramm",
        "failed": "Dieses Diagramm konnte nicht geladen werden",
        "retry": "Erneut versuchen"
      }
    }
  }
}
